
import {take} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { superLocalStorage } from '~common/app/shared/utils/local-storage';

import { AppService } from '../../../shared/services/app.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-auth-form-page',
  templateUrl: './auth-form-page.component.html',
  styleUrls: ['./auth-form-page.component.sass']
})
export class AuthFormPageComponent implements OnInit {
  public model = {
    remember: !!superLocalStorage.get('auth.token'),
    email: '',
    password: '',
    g_recaptcha: null
  };
  public loading: boolean;
  public error: any;
  public captcha = false;

  constructor(
    private appService: AppService,
    private authService: AuthService,
    private router: Router
  ) {
    this.appService.setTitle('auth.login.heading');
  }

  ngOnInit() {}

  onFormSubmitted(formComponent: any) {
    this.error = false;
    this.captcha = false;

    const { email, password, g_recaptcha, remember} = formComponent.model;

    this.authService.login(email, password, g_recaptcha, remember).pipe(take(1)).subscribe(
      () => {
        this.router.navigate([ '/performances' ]);
        this.authService.assessPasswordStrength(password).subscribe(() => null);
      },
      (error) => {
        this.model.g_recaptcha = null;

        if ((error.error && error.error.require_captcha) || (error.error.message && error.error.message.require_captcha)) {
          this.captcha = true;
        }

        this.error = error;
      }
    );
  }
}
